var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPortrait)?_c('SALESPOLICYPC'):_c('SALESPOLICY')
}
var staticRenderFns = []

export { render, staticRenderFns }